import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableDeviceConfigsUsage from './tableDeviceConfigsUsage';

export default {
  title: 'Used in Configs',
  attributeName: 'device-configs-usage',
  fields: [
    {
      attributeName: 'configsUsageTable',
      label: 'Configs using this device',
      type: FormInputTypes.TABLECOMPONENT,
      mode: 'NORMAL',
      helpText: 'List of configs where this deviceId is included in the config deviceId list.',
      configFile: tableDeviceConfigsUsage,
    },
  ],
};
